/* ============================================================
   HHM Sticky ATC — shows after scrolling past usage section
   ============================================================ */

(function() {
  'use strict';

  const stickyAtc    = document.getElementById('HHMStickyAtc');
  const stickyBtn    = document.querySelector('[data-sticky-atc-btn]');
  const triggerEl    = document.querySelector('[data-sticky-atc-trigger]');
  const productForm  = document.querySelector('[data-product-form]');
  const qtyDisplay   = document.querySelector('[data-sticky-qty-display]');
  const stickyNick   = document.querySelector('[data-sticky-variant-nickname]');
  const stickySize   = document.querySelector('[data-sticky-variant-size]');
  const stickyPrice  = document.querySelector('[data-sticky-price]');
  if (!stickyAtc) return;

  // Keep qty badge in sync with the stepper
  const qtyInput = document.querySelector('[data-qty-input]');
  if (qtyInput && qtyDisplay) {
    const syncQty = () => { qtyDisplay.textContent = qtyInput.value || '1'; };
    qtyInput.addEventListener('change', syncQty);
    document.addEventListener('hhm:qty-updated', syncQty);
  }

  // Sync nickname, size and price when variant is selected (via custom event from picker)
  document.addEventListener('hhm:variant-selected', e => {
    const d = e.detail;
    if (stickyNick)  stickyNick.textContent  = d.nickname || d.option1 || '';
    if (stickySize)  stickySize.textContent  = d.option1  || '';
    if (stickyPrice) stickyPrice.textContent = d.price    || '';
  });

  // Show only after the product form has scrolled past the top of the viewport
  const observeTarget = triggerEl || productForm;
  if (!observeTarget) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const pastTop = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      stickyAtc.classList.toggle('is-visible', pastTop);
    });
  }, { threshold: 0 });

  observer.observe(observeTarget);

  // Sticky ATC click — proxies current variant + qty to cart
  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      const variantInput = document.querySelector('[data-product-variant-id]');
      const qtyInput     = document.querySelector('[data-qty-input]');
      if (!variantInput) return;

      const variantId = variantInput.value;
      const qty       = parseInt(qtyInput?.value || '1', 10);

      stickyBtn.disabled = true;
      window.HHMCart?.add(variantId, qty)
        .finally(() => { stickyBtn.disabled = false; });
    });
  }

})();
